<template>
  <el-container class="main-shell">
    <el-aside width="260px" class="shell-aside">
      <common-aside class="shell-aside-inner"/>
    </el-aside>
    <el-container class="shell-content">
      <el-header class="shell-header">
        <common-header/>
      </el-header>
      <common-tag class="shell-tag"/>
      <el-main class="shell-main">
        <router-view/>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
// @ is an alias to /src
import CommonAside from '../components/CommonAside'
import CommonHeader from '../components/CommonHeader'
import CommonTag from '../components/CommonTag'

export default {
  name: 'Main',
  components: {
    CommonAside,
    CommonHeader,
    CommonTag
  }
}
</script>

<style lang="less">
.main-shell {
  min-height: 100vh;
  padding: 18px;
  gap: 18px;
  background: transparent;
}

.shell-aside {
  overflow: hidden;
  border: 1px solid rgba(36, 52, 70, 0.08);
  border-radius: 34px;
  background:
    radial-gradient(circle at top left, rgba(66, 109, 159, 0.14), transparent 30%),
    linear-gradient(180deg, rgba(244, 247, 251, 0.98), rgba(232, 238, 246, 0.96));
  box-shadow: 0 24px 52px rgba(36, 52, 70, 0.1);
}

.shell-aside-inner {
  width: 100%;
  height: 100%;
}

.shell-content {
  min-width: 0;
  gap: 14px;
}

.shell-header,
.shell-tag,
.shell-main {
  border: 1px solid var(--ui-border);
  border-radius: 30px;
  background: var(--ui-panel);
  box-shadow: 0 18px 48px rgba(37, 54, 57, 0.08);
  backdrop-filter: blur(12px);
}

.shell-header {
  height: 88px !important;
  padding: 0 24px !important;
}

.shell-tag {
  min-height: 62px;
}

.shell-main {
  padding: 22px !important;
  overflow: hidden;
}

@media (max-width: 1280px) {
  .main-shell {
    padding: 12px;
    gap: 12px;
  }

  .shell-aside {
    width: 230px !important;
  }

  .shell-main {
    padding: 16px !important;
  }
}
</style>
